import axios from 'axios'
// import { storeToRefs } from "pinia";
// import { useUserStore } from "@/store";
// const userStore = useUserStore();
// const { userLoginInfo } = storeToRefs(userStore);

// 创建 axios 实例 (axios 1.16.0 推荐配置)
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,  // 从环境变量读取基础URL
  timeout: 1000 * 60 * 10,  // 超时时间 10 分钟
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  },
  // axios 1.16.0 新增配置
  withCredentials: true,  // 允许携带凭证
  validateStatus: (status) => status >= 200 && status < 500  // 自定义状态码验证
})

// 请求拦截器 - 添加 token
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userToken')
    if (token && config.url?.includes('mos')) {
      config.headers.Authorization = `Bearer ${token}`
      config.headers.formplatformid = 8
      config.headers.tenantid = 2
      config.headers.formplatformcode = "YPLAN"
    }
    // 文件上传特殊处理
    if (config.url?.includes('upload-image')) {
      config.headers['Content-Type'] = 'multipart/form-data'
    }

    return config
  },
  (error) => {
    // 请求配置错误处理
    console.error('请求配置错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器 - 统一处理错误
request.interceptors.response.use(
  (response) => {
    // axios 1.16.0 响应结构
    const { data, status, statusText } = response
    return data
  },
  (error) => {
    // axios 1.16.0 错误处理
    const { response, request, message } = error
    if (response) {
      // 请求已发出，服务器响应
      const { status, statusText } = response
      // console.error(`HTTP 错误 ${status}: ${statusText}`)

      // 根据状态码做不同处理
      switch (status) {
        case 401:
          // console.error('未授权，请重新登录')
          // 清除 token 并重定向
          localStorage.removeItem('token')
          window.location.href = '/login'
          break
        case 403:
          // console.error('权限不足')
          break
        case 404:
          // console.error('请求资源不存在')
          break
        case 500:
          // console.error('服务器内部错误')
          break
        default:
        // console.error(`请求失败: ${status}`)
      }
    } else if (request) {
      // 请求已发出但没有收到响应
      // console.error('请求超时或网络异常')
    } else {
      // 请求配置错误
      // console.error('请求配置错误:', message)
    }

    return Promise.reject(error)
  }
)

// 封装常用请求方法
const http = {
  get: (url, params = {}, config = {}) => request.get(url, { params, ...config }),
  post: (url, data = {}, config = {}) => request.post(url, data, config),
  put: (url, data = {}, config = {}) => request.put(url, data, config),
  delete: (url, params = {}, config = {}) => request.delete(url, { params, ...config }),
  patch: (url, data = {}, config = {}) => request.patch(url, data, config),
}

export default http